import { Component, OnInit } from '@angular/core';
import {faSadTear} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-error-notfound',
    templateUrl: './error-notfound.component.html',
    styleUrls: ['./error-notfound.component.scss'],
    standalone: false
})
export class ErrorNotfoundComponent implements OnInit {

  faSadTear = faSadTear;

  constructor() { }

  ngOnInit(): void {
  }

}
